// extracted by mini-css-extract-plugin
export var content = "_pj-1";
export var noScroll = "_pj-3";
export var paper = "_pj-0";
export var scrollable = "_pj-2";